import Swal from "sweetalert2";
import "./draftNameDialog.css";

export const promptDraftName = ({ title, workspaceLabel, isExisting }) => {
  const theme = getComputedStyle(
    document.querySelector("[data-auth-theme]") || document.activeElement || document.body,
  );
  const themeValues = [
    "--app-surface", "--app-surface-text", "--app-border",
    "--app-subtle-text", "--app-input-bg", "--app-input-text",
  ].map((name) => [name, theme.getPropertyValue(name).trim()]);
  return Swal.fire({
    titleText: `儲存${workspaceLabel}暫存`,
    html: isExisting
      ? "保留原名稱即可繼續儲存，也可以在這裡重新命名。"
      : "為這份暫存取個容易辨認的名稱，方便下次接著編輯。",
    input: "text",
    inputLabel: "暫存名稱",
    inputValue: title.slice(0, 160),
    inputPlaceholder: "例如：國一・方程式練習",
    inputAttributes: { maxlength: "160", autocomplete: "off" },
    customClass: {
      popup: "draft-name-dialog",
      title: "draft-name-dialog__title",
      htmlContainer: "draft-name-dialog__description",
      inputLabel: "draft-name-dialog__label",
      input: "draft-name-dialog__input",
      actions: "draft-name-dialog__actions",
      confirmButton: "draft-name-dialog__save",
      cancelButton: "draft-name-dialog__cancel",
      validationMessage: "draft-name-dialog__validation",
    },
    buttonsStyling: false,
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: "儲存暫存",
    cancelButtonText: "取消",
    width: "min(460px, calc(100vw - 32px))",
    didOpen: (popup) => {
      themeValues.forEach(([name, value]) => {
        if (value) popup.style.setProperty(name, value);
      });
    },
    inputValidator: (value) =>
      String(value || "").trim() ? undefined : "請輸入暫存名稱。",
  });
};

// Another draft already has this name: overwrite it, keep both, or go back.
// "new" keeps the usual target: the selected draft, or a new draft.
// Resolves to { action: "overwrite" | "new" | "cancel", draft }.
export const findDuplicateDraft = (drafts, title, currentId) => {
  const name = String(title || "").trim();
  return (drafts || []).find((draft) => draft.id !== currentId && String(draft.title || "").trim() === name) || null;
};

export const confirmDraftOverwrite = async ({ draft, workspaceLabel }) => {
  if (!draft) return { action: "new", draft: null };
  const result = await Swal.fire({
    titleText: "已有同名暫存",
    text: `「${draft.title}」已經存在。要覆蓋那筆${workspaceLabel}暫存，還是保留兩筆同名的暫存？`,
    icon: "question",
    customClass: {
      popup: "draft-name-dialog",
      title: "draft-name-dialog__title",
      htmlContainer: "draft-name-dialog__description",
      actions: "draft-name-dialog__actions",
      confirmButton: "draft-name-dialog__save",
      denyButton: "draft-name-dialog__cancel",
      cancelButton: "draft-name-dialog__cancel",
    },
    buttonsStyling: false,
    showDenyButton: true,
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: "覆蓋",
    denyButtonText: "保留兩筆",
    cancelButtonText: "取消",
    width: "min(460px, calc(100vw - 32px))",
  });
  if (result.isConfirmed) return { action: "overwrite", draft };
  if (result.isDenied) return { action: "new", draft: null };
  return { action: "cancel", draft: null };
};
